<template>
  <div style="margin-top: 25px;">
    <b-carousel
        :ref="slideId"
        :id="slideId"
        v-model="slide"
        :interval="settingsInterval"
        :controls="controls"
        :indicators="indicators"
        background="#FFFFFF"
        :img-height="viewHeight"
        @sliding-start="handleSlidingStart"
        @sliding-end="handleSlidingEnd"
        :no-touch="true"
        :fade="settingsTransition"
    >
      <b-carousel-slide>
        <template #img>
          <board />
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
import ResourceNavBar from "@/components/blockResources/_components/resourceNavBar";
import Board from "./board";

export default {
  name: "Display_Speak",
  mixins: [ResourceBlockDisplay],
  components: {
    ResourceNavBar,
    Board
  },
  props: {},
  created() {},
  mounted() {
    //User can choose BG Music
    //this.playRepeat();
  },
  computed: {
    /* SETTINGS */
    /* SETTINGS */
    settingsInterval() {
      return this.settings && this.settings.user && this.settings.user.interval
        ? this.settings.user.interval * 1000
        : 4;
    },
    settingsTransition() {
      return this.settings &&
        this.settings.user &&
        this.settings.user.transition
        ? this.settings.user.transition === "fade"
        : true;
    },
    settings_autoPlayCreatedByAudio() {
      return this.settings &&
        this.settings.user &&
        this.settings.user._autoPlayCreatedByAudio !== undefined
        ? this.settings.user._autoPlayCreatedByAudio
        : true;
    },
    settings_autoPlayPhotoAudio() {
      return this.settings &&
        this.settings.user &&
        this.settings.user._autoPlayPhotoAudio !== undefined
        ? this.settings.user._autoPlayPhotoAudio
        : true;
    },
    settings_hideBottomBar() {
      return this.settings &&
        this.settings.user &&
        this.settings.user._hideBottomBar !== undefined
        ? this.settings.user._hideBottomBar
        : true;
    },
    settings_isRepeat() {
      return this.settings &&
        this.settings.user &&
        this.settings.user._isRepeat !== undefined
        ? this.settings.user._isRepeat
        : true;
    },
    settings_isShuffle() {
      return this.settings &&
        this.settings.user &&
        this.settings.user._isShuffle !== undefined
        ? this.settings.user._isShuffle
        : true;
    },
    /* DATA */
    userDataPhotos() {
      return this.userData && this.userData.photos
        ? this.userData.photos
        : DefaultPhotos;
    }
  },
  methods: {
    playRepeat() {
      if (this.playInd < this.userDataPhotos.length) {
        //Just in case a new one is added or deleted during play
        const audioURL = `${this.assetsURLHome}${
          this.userDataPhotos[this.playInd].audioURL
        }`;
        this.player = new Audio(audioURL);

        let that = this; // Check that there are no issues with this
        this.player.addEventListener("ended", function() {
          that.player.currentTimer = 0;
          that.playInd++; //If shuffle- then randomize
          that.handleGoToSlideAudioWith(that.playInd);
          that.playRepeat();
        });
        //this.audioDuration = this.getDuration(this.player.duration);
        if (this.player) {
          this.player.play();
        }
      } else {
        this.playInd = 0;
      }
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    handleSlidingStart(numberSlidingTo) {},
    handleSlidingEnd(numberSlidTp) {
      //Pause slide to play audio

      if (this.settings_autoPlayPhotoAudio) {
        let thePhoto =
          this.userDataPhotos.length > numberSlidTp
            ? this.userDataPhotos[numberSlidTp]
            : null;
        if (thePhoto.audioURL) {
          this.handlePlayAudio(thePhoto.audioURL);
        }
      }
    },
    handlePlayAudio(audioURL) {
      this.player = new Audio(audioURL);
      if (this.player) {
        this.$refs[this.slideId].pause();
        let that = this;
        this.player.addEventListener("ended", function() {
          that.player.pause();
          that.$refs[that.slideId].start();
        });
        //Pause to allow to play
      }
      if (this.player) {
        this.player.play();
      }
    },
    handleOpenSideBar() {
      this.sidebarModel = true;
    },
    handleCloseSideBar() {
      this.sidebarModel = false;
    },
    handleGoToSlideAudioWith(audioInd) {
      this.$refs[this.slideId].setSlide(audioInd);
    },
    handleShowPhotos() {
      this.handleOpenSideBar();
    },
    handlePlayItem(item) {
      let currentIndexOfItem = Array.isArray(this.userDataPhotos)
        ? this.userDataPhotos.findIndex(x => x.imgURL === item.imgURL)
        : 0;
      //@ToDo keying off the imgURL may or may not be permanent
      //@ToDo, should I require Id for all the item objectss
      this.playInd = currentIndexOfItem;
      this.handleGoToSlideAudioWith(currentIndexOfItem);
      this.handleCloseSideBar();
    }
  },
  data() {
    return {
      DefaultPhotos,
      assetsURLHome: "", //assets/apps/photoalbum/',
      audioDuration: null,
      sidebarId: "photos-sidebar",
      sidebarModel: false,
      /* SLIDE INFO*/
      viewHeight: 250,
      slideId: "audioSlides",
      controls: false,
      indicators: false,
      slide: 0,
      sliding: null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
